






















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
  import { Wishlist } from '@one/types/dist/orderpath/app'

  @Component
  export default class OneWishlistModalRename extends Vue {
    wishlistName: string = ''

    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Object,
      required: true,
    })
    currentWishlist!: Wishlist.Responses.Wishlist;

    @Prop({
      type: Boolean,
      required: true,
    })
    progress!: boolean;

    @Prop({
      type: Number,
      required: false,
      default: 17,
    })
    max!: number;

    get isValid() {
      return this.wishlistName.trim().length < this.max
    }

    @Watch('value')
    onVisibilityChange() {
      this.wishlistName = ''
    }

    onRename() {
      this.$emit('rename', this.wishlistName.trim())
    }
  }
